<template>
  <div>
    <div class="exam__detail__block p-3">
      <b-row>
        <b-col>
          <div class="package__purchase__detail">
            <div class="package__purchase__detail__name mb-3">
              <span>Đề thi đã chọn</span>
              <h3 class="text-red">{{ exam.name }}</h3>
              <p>Giá: {{ exam.price.toLocaleString() }} VNĐ</p>
              <div><strong class="text-red">Số lượng đề thi: 01</strong></div>
              <strong class="text-red">&nbsp;</strong>
            </div>

            <div>Tổng tiền Thanh toán</div>

            <div class="text-red">{{ exam.price.toLocaleString() }} VNĐ</div>

            <div>Số dư ví</div>

            <div class="text-red">{{ user.balance.toLocaleString() }} VNĐ</div>

            <template v-if="user.balance >= exam.price">
              <b-btn @click="purchase" class="btn">Thanh toán</b-btn>
            </template>
            <template v-else>
              <b-link :to="{ name: 'user-topup' }" class="btn"
                >Nạp thêm tiền</b-link
              >
            </template>
          </div>
        </b-col>
        <b-col>
          <div class="package__purchase__detail">
            <div class="package__purchase__detail__name mb-3">
              <span>Khoá học gợi ý</span>
              <h3 class="text-red">{{ examCombo.package.name }}</h3>
              <p>Giá: {{ examCombo.package.price.toLocaleString() }} VNĐ</p>
              <div><strong class="text-red">Số lượng đề thi: <span v-if="(examCombo.package.totalExam < 10)">0{{examCombo.package.totalExam}}</span> <span v-else>{{ examCombo.package.totalExam }}</span></strong></div>
              <strong class="text-red">Gói luyện tập: {{ examCombo.class.name }}</strong>
            </div>

            <div>Tổng tiền gói học</div>

            <div class="text-red">{{ examCombo.package.price.toLocaleString() }} VNĐ</div>

            <div>Số dư ví</div>

            <div class="text-red">{{ user.balance.toLocaleString() }} VNĐ</div>

            <template v-if="user.balance >= examCombo.package.price">
              <b-link class="btn" :to="{ name: 'package-purchase', params: { id: 2 }, query: { class: 5 }}">
                Mua gói luyện
              </b-link>
            </template>
            <template v-else>
              <b-link :to="{ name: 'user-topup' }" class="btn"
                >Nạp thêm tiền</b-link
              >
            </template>
          </div>
        </b-col>
      </b-row>

      <div class="text-red">
        <h6 class="text-center">Lời khuyên</h6>
        <p class="text-center mb-0">Nên chọn mua theo gói luyện để đảm bảo đạt kết quả tốt nhất cũng như tiết kiệm 70% so với mua từng đề.</p>
        <p class="text-center">Mua theo gói sẽ mở khoá toàn bộ đề thi lẻ và luyện tập.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";

export default {
  name: "ExamPurchase",
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
    };
  },
  computed: {
    ...mapGetters({
      user: `auth/user`,
      exam: `${STORE_KEY}/exam`,
      examCombo: `${STORE_KEY}/examCombo`,
    }),
    ...mapGetters("auth", ["user"]),
  },
  beforeMount() {
    this.getExamInfo(this.id);
    this.getExamCombo(this.id);
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["getExamInfo", "getExamCombo", "getExamPurchase"]),
    purchase() {
      this.getExamPurchase({ id: this.id, slug: this.slug });
    },
  },
};
</script>
